import { render, staticRenderFns } from "./WritingDoneNotification.vue?vue&type=template&id=87ce05e8&"
import script from "./WritingDoneNotification.vue?vue&type=script&lang=js&"
export * from "./WritingDoneNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports